import { ErrorToast } from './ErrorToast'
import { toast, ToastPosition } from 'react-toastify'
import { ErrorToastData } from '../../types/Core/ErrorToastData'
import { useEnvironmentVariables } from '../../components/hooks/useEnvironmentVariables'

const showErrorToast = (data: ErrorToastData, position: ToastPosition | undefined = undefined) => {
	const { showErrorToasts } = useEnvironmentVariables()
	if (!showErrorToasts) return

	toast.error<ErrorToastData>(ErrorToast, {
		position,
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: 'colored',
		data: {
			message: data.message,
			traceId: data.traceId,
			eventId: data.eventId,
		},
	})
}

const showSuccessToast = (
	message: string,
	ignoreEnvironment = false,
	position: ToastPosition | undefined = undefined,
) => {
	const { showSuccessToasts } = useEnvironmentVariables()
	if (!showSuccessToasts && !ignoreEnvironment) return
	toast.success(message, {
		position,
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: 'colored',
	})
}

const showWarningToast = (message: string) => {
	toast.warning(message, {
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		theme: 'colored',
	})
}

export { showErrorToast, showSuccessToast, showWarningToast }
